export interface PlaceSuggestion {
  displayName: string
  latitude: number
  longitude: number
}

// Nominatim (OpenStreetMap's free geocoding service) — no API key, no cost.
// Usage policy asks for at most ~1 request/second; callers must debounce.
export async function searchPlaces(query: string): Promise<PlaceSuggestion[]> {
  const url = `https://nominatim.openstreetmap.org/search?format=json&limit=5&q=${encodeURIComponent(query)}`
  const response = await fetch(url)
  if (!response.ok) throw new Error('Place search failed')
  const data = (await response.json()) as Array<{ display_name: string; lat: string; lon: string }>
  return data.map((item) => ({
    displayName: item.display_name,
    latitude: Number(item.lat),
    longitude: Number(item.lon),
  }))
}
